// extracted by mini-css-extract-plugin
export default {"closeFull":"CloseFullWindow_closeFull__zxOx+"};